import { Suspense, lazy, type ComponentProps } from 'react'

/**
 * xterm.js (~130 KB minified) is the single heaviest thing in the bundle and NOTHING
 * on the path from login to the sidebar needs it — the terminal only mounts when a
 * pane is actually shown (AgentPanel's `terminal-view` mode, the PromptSheet). Loading
 * TerminalView through React.lazy keeps xterm and its addons out of the initial chunk;
 * they arrive the first time a terminal is opened, then the browser caches the chunk
 * for the rest of the session (M9).
 *
 * The fallback is the terminal's own empty frame (`.tv-wrap`), so the panel holds its
 * geometry while the chunk lands rather than collapsing and jumping.
 */
const TerminalViewImpl = lazy(() =>
  import('./TerminalView').then((m) => ({ default: m.TerminalView })),
)

type Props = ComponentProps<(typeof import('./TerminalView'))['TerminalView']>

export function TerminalViewLazy(props: Props) {
  return (
    <Suspense fallback={<div className="tv-wrap" aria-busy="true" />}>
      <TerminalViewImpl {...props} />
    </Suspense>
  )
}
